/* ADD Knowledge categories */
export const ADD_SHOPPING_AREA = "ADD_SHOPPING_AREA"
export const ADD_SHOPPING_AREA_SUCCESS = "ADD_SHOPPING_AREA_SUCCESS"
export const ADD_SHOPPING_AREA_CLEAN = "ADD_SHOPPING_AREA_CLEAN"
export const ADD_SHOPPING_AREA_ERROR = "ADD_SHOPPING_AREA_ERROR"
